/**
 * This type guard asserts that the passed value is not null, or undefined, thus satisfying the requirements for NonNullable<T>.
 * @param candidate The value to test
 * @returns true if the value is not null or undefined
 */
export default function isNonNullable<T>(
  candidate: T,
): candidate is NonNullable<T> {
  return candidate !== null && candidate !== undefined;
}
